var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolderDownIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BB0DF8EA-8E0B-4E18-AEFF-B2F128D11B4C") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M19,2 L9.414,2 L7.707,0.293 C7.52,0.105 7.266,0 7,0 L1,0 C0.447,0 0,0.447 0,1 L0,19 C0,19.553 0.447,20 1,20 L19,20 C19.553,20 20,19.553 20,19 L20,3 C20,2.447 19.553,2 19,2 L19,2 Z M9,11.5859 L7.707,10.2929 C7.316,9.9019 6.684,9.9019 6.293,10.2929 C5.902,10.6839 5.902,11.3159 6.293,11.7069 L9.293,14.7069 C9.488,14.9019 9.744,14.9999 10,14.9999 C10.256,14.9999 10.512,14.9019 10.707,14.7069 L13.707,11.7069 C14.098,11.3159 14.098,10.6839 13.707,10.2929 C13.316,9.9019 12.684,9.9019 12.293,10.2929 L11,11.5859 L11,7.9999 C11,7.4469 10.553,6.9999 10,6.9999 C9.447,6.9999 9,7.4469 9,7.9999 L9,11.5859 Z M18,18 L2,18 L2,2 L6.586,2 L8.293,3.707 C8.48,3.895 8.734,4 9,4 L18,4 L18,18 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vendor",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vendor-Registration-/-Personal-Info",
    transform: "translate(-958.000000, -147.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(941.000000, 132.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(8.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Polaris-icon/Major/Mono/Folder-Down",
    transform: "translate(9.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Icon",
    fill: "#9C6ADE",
    xlinkHref: "#path-1"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderDownIcon);
export default __webpack_public_path__ + "static/media/folder_down_icon.77a9a1e8.svg";
export { ForwardRef as ReactComponent };